export default "__VITE_ASSET__D5$y6GAD__"